<template>
  <div :class="wrapperClass">
    <!--  slot before list  -->
    <slot name="list:before" />
    <div v-for="(button, index) in value" :class="handleItemClass(button, index)" v-bind:key="button[trackBy]">
        <b-button size="lg" 
            :class="button.active ? `text-white active btn-light` : `text-dark text-decoration-none`" 
            :variant="button.active ? `primary` : `link`"
            @click="handleButtonClick(button)"
            :block="button.props && button.props.block !== undefined ? button.props.block : true"
            v-bind="button.props" 
        >{{ labelFormat(button.value, button.text) }}</b-button>
    </div>
    <!--  slot after list  -->
    <slot name="list:after" />
  </div>
</template>
<script>
export default {
    name: "segmented-button",
    props: {
        value: {
            type: Array, // text & value
            default: () => [],
        },
        labelFormat: {
            type: Function,
            default: (_, text) => text
        },
        itemClass: {
            type: [Function, String],
            default: undefined
        },
        wrapperClass: {
            type: String,
            default: `rounded border row py-2 segment-wrapper`
        },
        trackBy: {
            type: String,
            default: 'value',
        }
    },
    methods: {
        handleButtonClick(event){
            const buttons = this.value.map((button) => ({
                ...button,
                active: button[this.trackBy] === event[this.trackBy]
            }))
            this.$emit('input', buttons);
        },
        handleItemClass(button, index){
            if(typeof this.itemClass === 'function'){
                return this.itemClass(button, index)
            }else if(this.itemClass){
                return this.itemClass
            }

            return `col-md-${12/(this.value || []).length}`
        }
    }
};
</script>

<style lang="scss" scoped>
  .segment-wrapper {
    background: #FAFAFA;

    button.active{
        font-weight: 700;
        font-size: 14px;
        line-height: 16px;
        color: #FFFFFF;
        background: #0084F3;
    }
    button:not(.active){
        font-weight: 700;
        font-size: 14px;
        line-height: 16px;
        color: #454646 !important;
    }
  }
</style>